"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Card_1 = require("@mui/material/Card");
var material_1 = require("@mui/material");
var Fab_1 = require("@mui/material/Fab");
var Add_1 = require("@mui/icons-material/Add");
var Sponsor_1 = require("./Sponsor");
var SponsorModal_1 = require("./SponsorModal");
var Sponsor_2 = require("../models/Sponsor");
var SponsorService_1 = require("../services/SponsorService");
var Role_1 = require("../shared/utilities/Role");
var Toast_1 = require("../shared/utilities/Toast");
var useRef = React.useRef;
var StyledCard = styles_1.styled(Card_1.default)({
    color: 'darkslategray',
    backgroundColor: '#F3F3F3',
    marginBottom: 8,
    borderRadius: 4,
});
var ImageStyleLeft = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'left',
    padding: '10px'
};
var ImageStyleRight = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'right',
    padding: '10px'
};
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
/*const originalSponsors: SponsorModel[] = [
    {
        id: '0',
        body: 'When you choose Tempstar® heating and cooling equipment, you’re choosing enhanced dependability and innovation in home comfort. They are proud to give you the latest in engineering and technology. Tempstar® products are designed to deliver the best in quality, energy efficiency and reliability, and each is 100% run tested. Tempstar® takes pride in surpassing your expectations and delivering quality you can feel. \n \n As your Northshore Tempstar Elite Dealer we have the knowledge, experience, and training to help your system achieve peak performance.',
        name: 'University of Waterloo',
        phoneNumber: '(123)-123-1234',
        email: 'jeff@test.com',
        website: 'www.test.com',
        logoLocation: '/assets/images/University_of_Waterloo.png'
    },
    {
        id: '1',
        body:'When you choose Tempstar® heating and cooling equipment, you’re choosing enhanced dependability and innovation in home comfort. They are proud to give you the latest in engineering and technology. Tempstar® products are designed to deliver the best in quality, energy efficiency and reliability, and each is 100% run tested. Tempstar® takes pride in surpassing your expectations and delivering quality you can feel. \n \n As your Northshore Tempstar Elite Dealer we have the knowledge, experience, and training to help your system achieve peak performance.',
        name: 'Tempstar Heating',
        phoneNumber: '(123)-123-1234',
        email: 'jeff@test.com',
        website: 'www.test.com',
        logoLocation: '/assets/images/University_of_Waterloo.png'
    },
]*/
function Sponsors() {
    var role = Role_1.default();
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), ready = _b[0], setReady = _b[1];
    var modalRef = useRef(null);
    var _c = React.useState([]), sponsors = _c[0], setSponsors = _c[1];
    var _d = React.useState(3), maxId = _d[0], setMaxId = _d[1];
    var openSponsorModal = function (sponsor) {
        var _a, _b;
        if (sponsor == null || sponsor.SponsorId == '') {
            var newSponsor = new Sponsor_2.SponsorModel();
            modalRef && ((_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen(newSponsor));
        }
        else {
            modalRef && ((_b = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _b === void 0 ? void 0 : _b.handleOpen(sponsor));
        }
    };
    var deleteSponsor = function (id) {
        setReady(false);
        var sponsor = sponsors.filter(function (sponsor) { return sponsor.SponsorId == id; })[0];
        SponsorService_1.default.UpdateSponsor(sponsor.SponsorId, sponsor.SponsorName, sponsor.SponsorPhoneNumber, sponsor.SponsorEmail, sponsor.SponsorWebsite, sponsor.SponsorDescription, null, null, true).then(function (response) {
            if (response != null && response.Sponsor != null) {
                var newSetSponsors = __spreadArray([], sponsors);
                var index = newSetSponsors.map(function (sponsor) { return sponsor.SponsorId; }).indexOf(id);
                newSetSponsors.splice(index, 1);
                setSponsors(__spreadArray([], newSetSponsors));
                showSuccessMessage('Sponsor deleted successfully!');
            }
            else {
                showErrorMessage('Unknown error occured deleting sponsor!');
            }
            setReady(true);
        });
    };
    var upsertSponsor = function (sponsor, logoBytes, logoName) {
        setReady(false);
        if (sponsor.SponsorId == null || sponsor.SponsorId == '') {
            SponsorService_1.default.CreateSponsor(sponsor.SponsorName, sponsor.SponsorPhoneNumber, sponsor.SponsorEmail, sponsor.SponsorWebsite, sponsor.SponsorDescription, logoName, logoBytes).then(function (response) {
                if (response != null && response.Sponsor != null) {
                    var newSetSponsors = sponsors;
                    newSetSponsors.unshift(response.Sponsor);
                    setSponsors(__spreadArray([], newSetSponsors));
                    showSuccessMessage('Sponsor added successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured adding sponsor!');
                }
                setReady(true);
            });
        }
        else {
            SponsorService_1.default.UpdateSponsor(sponsor.SponsorId, sponsor.SponsorName, sponsor.SponsorPhoneNumber, sponsor.SponsorEmail, sponsor.SponsorWebsite, sponsor.SponsorDescription, logoName, logoBytes, false).then(function (response) {
                if (response != null && response.Sponsor != null) {
                    var newSetSponsors = __spreadArray([], sponsors);
                    var index = newSetSponsors.map(function (sponsor) { return sponsor.SponsorId; }).indexOf(response.Sponsor.SponsorId);
                    var item = __assign(__assign({}, sponsors[index]), { SponsorDescription: response.Sponsor.SponsorDescription, SponsorEmail: response.Sponsor.SponsorEmail, SponsorLogoLocation: response.Sponsor.SponsorLogoLocation, SponsorName: response.Sponsor.SponsorName, SponsorPhoneNumber: response.Sponsor.SponsorPhoneNumber, SponsorWebsite: response.Sponsor.SponsorWebsite });
                    newSetSponsors[index] = item;
                    setSponsors(__spreadArray([], newSetSponsors));
                    showSuccessMessage('Sponsor updated successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured updating sponsor!');
                }
                setReady(true);
            });
        }
    };
    React.useEffect(function () {
        console.log('effect used');
        SponsorService_1.default.GetSponsors().then(function (response) {
            if (response != null && response.Sponsors != null) {
                setSponsors(response.Sponsors);
                setReady(true);
            }
            else {
                showErrorMessage('Unknown error occured getting sponsors!');
            }
        });
    }, []);
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3, marginBottom: '40px' } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                role === 'Admin' &&
                    React.createElement(Fab_1.default, { color: "primary", style: { float: 'right', marginBottom: '8px', marginRight: '8px' }, variant: "extended", onClick: function () {
                            openSponsorModal(new Sponsor_2.SponsorModel());
                        } },
                        React.createElement(Add_1.default, null),
                        " Add New Sponsor"),
                React.createElement("br", null),
                React.createElement(material_1.List, null, sponsors.map(function (sponsor, index) { return (React.createElement(material_1.ListItem, null,
                    React.createElement(Sponsor_1.default, { key: sponsor.SponsorId, id: sponsor.SponsorId, body: sponsor.SponsorDescription, name: sponsor.SponsorName, phoneNumber: sponsor.SponsorPhoneNumber, email: sponsor.SponsorEmail, website: sponsor.SponsorWebsite, logoLocation: sponsor.SponsorLogoLocation, side: index % 2 == 0 ? 'left' : 'right', openSponsorModal: openSponsorModal, delete: deleteSponsor }))); }))),
        React.createElement(SponsorModal_1.default, { ref: modalRef, upsertSponsor: upsertSponsor })));
}
exports.default = Sponsors;
//# sourceMappingURL=Sponsors.js.map